import { atom } from 'jotai';
import {
  getAppFlowIdFromUsecaseKey,
  getAppFrustrationSignalIdFromUsecaseKey,
  getAppEventIdFromUsecaseKey,
} from '@utils/preset';

// Saved dashboard id (number) or sharing dashboard ID (sharing-${number})
export const dashboardIdAtom = atom<string | `sharing-${number}` | null>(null);

// Temporary drilldown dashboard key, should be a number string, starting from 1
export const pageKeyAtom = atom('');

// Used to store preset key or drilldown origin, would be widget type if it's from widget drilldown
export const useCaseKeyAtom = atom<
  string | `flow:${number}` | `frustration-signal:${string}` | `event:${string}`
>('');

// Flags to indicate if the dashboard is a saved dashboard, sharing dashboard, or public saved dashboard.
export const isSavedDashboardAtom = atom(false);
export const isSharingAtom = atom(false);
export const isPublicSavedDashboardAtom = atom(false);

// Flag to indicate comparison interval was explicitly set and shouldn't be auto-calculated
// (e.g., from Nexa DoD merged links or other sources with explicit comparison)
export const hasExplicitComparisonAtom = atom(false);

// Derived atom: true if this is a Nexa drilldown dashboard (based on usecaseKey)
export const isNexaDrilldownAtom = atom((get) => {
  const useCaseKey = get(useCaseKeyAtom);
  return useCaseKey === 'nexa-drilldown';
});

// Always return flow preset id if the current is flow preset dashboard.
const flowPresetIdAtom = atom((get) => {
  const useCaseKey = get(useCaseKeyAtom);
  return getAppFlowIdFromUsecaseKey(useCaseKey);
});

// Always return frustration signal preset id if the current is frustration signal preset dashboard.
const frustrationSignalPresetIdAtom = atom((get) => {
  const useCaseKey = get(useCaseKeyAtom);
  return getAppFrustrationSignalIdFromUsecaseKey(useCaseKey);
});

// Always return event preset id if the current is event preset dashboard.
const eventPresetIdAtom = atom((get) => {
  const useCaseKey = get(useCaseKeyAtom);
  return getAppEventIdFromUsecaseKey(useCaseKey);
});

export const pageMetaAtom = atom((get) => ({
  id: get(dashboardIdAtom),
  pageKey: get(pageKeyAtom),
  useCaseKey: get(useCaseKeyAtom),
  isSavedDashboard: get(isSavedDashboardAtom),
  isSharing: get(isSharingAtom),
  isPublicSavedDashboard: get(isPublicSavedDashboardAtom),
  flowPresetId: get(flowPresetIdAtom),
  frustrationSignalPresetId: get(frustrationSignalPresetIdAtom),
  eventPresetId: get(eventPresetIdAtom),
}));
